export const cleanHTML = (text: string): string => {
  return text.replace(/<[^>]*>/g, ""); // Supprime les balises HTML
};

/**
 * Convertit du HTML en texte brut en préservant les sauts de ligne
 */
export const htmlToRawText = (html: string | null | undefined): string => {
  if (!html) return "";

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  function walk(node: Node, listContext: "ol" | "ul" | null = null): string {
    if (node.nodeType === Node.TEXT_NODE) {
      return (node.textContent ?? "").trim();
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      return "";
    }

    const el = node as HTMLElement;
    let result = "";

    switch (el.tagName) {
      case "BR":
        return "\n";

      case "P":
      case "DIV":
        result += walkChildren(el) + "\n\n";
        break;

      case "UL":
        result += walkChildren(el, "ul") + "\n";
        break;

      case "OL":
        result += walkChildren(el, "ol") + "\n";
        break;

      case "LI":
        if (listContext === "ol") {
          const index =
            Array.from(el.parentElement?.children ?? []).indexOf(el) + 1;
          result += `${index}. ${walkChildren(el)}\n`;
        } else {
          result += `- ${walkChildren(el)}\n`;
        }
        break;

      default:
        result += walkChildren(el, listContext);
        break;
    }

    return result;
  }

  function walkChildren(
    node: HTMLElement,
    listContext: "ol" | "ul" | null = null,
  ): string {
    let txt = "";
    node.childNodes.forEach((child) => (txt += walk(child, listContext)));
    return txt;
  }

  return walk(doc.body)
    .replace(/\n{3,}/g, "\n\n") // éviter trop de lignes vides
    .trim();
};

// Extension TypeScript pour String
declare global {
  interface String {
    htmlToRawText(): string;
  }
}

String.prototype.htmlToRawText = function (): string {
  return htmlToRawText(this.toString());
};
